import { Component, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';
import { CosmeticOptions } from '../../models/filter-models';
import { Rarity } from '../../models/enums';
import { CosmeticStyleClipboardService } from '../../services/cosmetic-style-clipboard.service';
import { StyleLibraryPickerDialogComponent } from '../style-picker/style-library-picker-dialog/style-library-picker-dialog.component';
import { DelayedMouseleaveDirective } from '../delayed-mouseleave/delayed-mouseleave.directive';

@Component({
  selector: 'app-cosmetic-style-options-menu',
  imports: [StyleLibraryPickerDialogComponent, DelayedMouseleaveDirective],
  templateUrl: './cosmetic-style-options-menu.component.html',
  styleUrl: './cosmetic-style-options-menu.component.scss',
})
export class CosmeticStyleOptionsMenuComponent {
  private readonly styleClipboard = inject(CosmeticStyleClipboardService);

  @Input() disabled = false;
  @Input({ required: true }) getCopyOptions!: () => CosmeticOptions | null | undefined;
  @Input({ required: true }) getCopyNameHint!: () => string | undefined;
  @Input({ required: true }) applyPaste!: (options: CosmeticOptions) => void;

  @Input() exampleName?: string;
  @Input() rarity?: Rarity;
  @Input() sockets?: string;
  @Input() influence?: string;
  @Input() fractured?: boolean;
  @Input() veiled?: boolean;
  @Input() isCurrency?: boolean;
  @Input() isWaystone?: boolean;
  @Input() isPoe1Gem?: boolean;
  @Input() isDivinationCard?: boolean;
  @Input() isQuestItem?: boolean;
  @Input() forceHidden?: boolean;

  @Output() menuAction = new EventEmitter<void>();

  menuOpen = false;
  libraryPickerOpen = false;
  canCopyStyle = false;

  hasClipboard = this.styleClipboard.hasClipboard;
  hasLibraryEntries = this.styleClipboard.hasLibraryEntries;

  toggleMenu(event: Event) {
    event.stopPropagation();
    if (this.disabled) return;
    this.menuOpen = !this.menuOpen;
    if (this.menuOpen) {
      this.refreshMenuState();
    }
  }

  private refreshMenuState() {
    this.canCopyStyle = this.styleClipboard.canCopy(this.getCopyOptions());
  }

  closeMenu() {
    this.menuOpen = false;
  }

  copyStyle() {
    const options = this.getCopyOptions();
    if (!options || !this.styleClipboard.canCopy(options)) return;
    this.styleClipboard.copy(options, this.getCopyNameHint());
    this.closeMenu();
  }

  pasteStyle() {
    const options = this.styleClipboard.getClipboardOptions();
    if (!options) return;
    this.applyPaste(options);
    this.closeMenu();
    this.menuAction.emit();
  }

  openLibraryPicker() {
    if (!this.hasLibraryEntries()) return;
    this.closeMenu();
    this.libraryPickerOpen = true;
  }

  onLibrarySelected(options: CosmeticOptions) {
    this.applyPaste(options);
    this.libraryPickerOpen = false;
    this.menuAction.emit();
  }

  closeLibraryPicker() {
    this.libraryPickerOpen = false;
  }

  onPanelClick(event: Event) {
    if ((event.target as HTMLElement).closest('button')) {
      this.closeMenu();
    }
  }
}
